import { Component, OnInit } from '@angular/core';
import { PlatformInviewService } from 'src/app/core/services/utelize/general/platform-inview-service';
import { VersionService } from 'src/app/core/services/utelize/general/version-service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})

export class FooterComponent implements OnInit {

  public ourCompanyName: string=this.platformInviewService.getOurCompanyName();
  public version       : string=<string>this.versionService.version;
  public year          : number=new Date().getFullYear();

  constructor(
    private platformInviewService: PlatformInviewService,
    private versionService       : VersionService
  ) { }

  ngOnInit(): void { }
}
